import { BrlFormatCurrency, FormatPoints } from "lib";

// Formata um valor respeitando o payment_mode do whitelabel (money / points / both).
export function formatValue(displayMode, money, points) {
  if (displayMode === "points") return `${FormatPoints(points)} pts`;
  if (displayMode === "both") {
    return `${BrlFormatCurrency(money)} ou ${FormatPoints(points)} pts`;
  }
  return BrlFormatCurrency(money);
}
